<template>
  <md-card>
    <md-card-content>
      <div style="display: flex; justify-content: flex-end">
        <md-switch v-model="value.enabled">Active</md-switch>
      </div>
      <h4>When</h4>
      <ValidationObserver ref="validator" tag="div" class="md-layout">
        <div class="md-layout-item  md-medium-size-100  md-size-50">
          <ValidationProvider rules="required" v-slot="{ failed }" slim>
            <md-field :class="[{ 'md-error': failed }]">
              <label>Name</label>
              <md-input v-model="value.name" required />
            </md-field>
          </ValidationProvider>
          <date-window v-bind:value="value.travel_windows">
            <template v-slot:label>TW</template>
          </date-window>
          <week-days-select v-model="value.travel_days_of_week">
            <template v-slot:label>Days of the week TW</template>
          </week-days-select>
          <room-type-select v-model="value.room_type_ids" multiple></room-type-select>
        </div>
        <div class="md-layout-item md-medium-size-100 md-size-50">
          <md-field>
            <label>Anticipation mode</label>
            <md-select v-model="value.anticipation_mode">
              <md-option value="BOOKING_WINDOW">Booking Window</md-option>
              <md-option value="ANTICIPATION_DAYS">Days before arrival</md-option>
            </md-select>
          </md-field>
          <date-window v-if="value.anticipation_mode == 'BOOKING_WINDOW'" v-model="value.booking_windows">
            <template v-slot:label>BW</template>
          </date-window>
          <div class="date-window" v-if="value.anticipation_mode == 'ANTICIPATION_DAYS'">
            <label class="date-window-label">
              DBA
            </label>
            <div class="anticipation-widget">
              <ValidationProvider name="from" rules="required|between:-6000,0" v-slot="{ failed, errors }" slim>
                <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }]">
                  <md-input type="number" max="0" v-model="value.anticipation_days_from" placeholder="From"></md-input>
                  <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                </md-field>
              </ValidationProvider>
              <span class="splitter"><md-icon>arrow_forward</md-icon></span>
              <ValidationProvider name="to" rules="required|between:-6000,0" v-slot="{ failed, errors }" slim>
                <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }]">
                  <md-input type="number" max="0" v-model="value.anticipation_days_to" placeholder="To"></md-input>
                  <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                </md-field>
              </ValidationProvider>
            </div>
          </div>
          <week-days-select v-model="value.booking_days_of_week">
            <template v-slot:label>Days of the week BW/DBA</template>
          </week-days-select>
        </div>

        <slot name="extraHeaderFields" v-bind:value="value" />
        <!-- Specific rules up here -->
        <slot name="default" v-bind:value="value" />
        <!-- ---------------------- -->
      </ValidationObserver>
    </md-card-content>
    <md-card-actions>
      <md-button class="md-success" v-on:click="save">Save</md-button>
      <md-button class="md-danger" v-on:click="confirmAndDelete">Delete</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import DateWindow from '@/components/Pricing/Inputs/DateWindow.vue'
import RoomTypeSelect from '../../../../components/Inputs/RoomTypeSelect.vue'

import WeekDaysSelect from '../../../../components/Pricing/Inputs/WeekDaysSelect.vue'
import { extend } from 'vee-validate'
import { between } from 'vee-validate/dist/rules'

extend('between', { ...between, message: 'Valid value between {min} and {max}' })

export default {
  name: 'StrategyItem',
  props: {
    item: Object,
    endpoints: Object,
  },
  data() {
    return {
      value: {},
    }
  },
  components: {
    DateWindow,
    RoomTypeSelect,
    WeekDaysSelect,
  },
  methods: {
    loadStrategy(item) {
      if (item.id) {
        this.endpoints.get(this.$root.hotelId, item.id, (error, data) => {
          this.value = data
        })
      } else {
        this.value = item
      }
    },
    async save() {
      const isValid = await this.$refs.validator.validate()
      if (isValid) {
        if (this.value.id) {
          this.endpoints.update(this.$root.hotelId, this.value.id, this.endpoints.create(this.value), (error, data) => {
            if (!error && data) {
              this.$emit('saved', data)
            }
          })
        } else {
          this.endpoints.save(this.$root.hotelId, this.endpoints.create(this.value), (error, data) => {
            if (!error && data) {
              this.value = data
              this.$emit('saved', data)
            }
          })
        }
      } else {
        this.$notify({
          timeout: 2500,
          message: '<strong>Not saved</strong>. Please check your inputs',
          icon: 'check_box',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger',
        })
      }
    },
    confirmAndDelete() {
      if (confirm('Are you sure?'))
        if (this.value.id) {
          this.endpoints.delete(this.$root.hotelId, this.value.id, (error, data) => {
            this.$emit('deleted')
          })
        } else {
          this.$emit('deleted')
        }
    },
  },
  watch: {
    item: function(newValue) {
      this.loadStrategy(newValue)
    },
  },
  created() {
    this.loadStrategy(this.item)
  },
}
</script>
<style lang="scss">
.anticipation-widget {
  display: flex;
  justify-content: space-between;
  //width: calc(100% - 82px);
  .splitter {
    display: flex;
    align-content: center;
    width: 60px;
  }
  .md-input {
    width: 65%;
  }
}
</style>
